import { Module } from "vuex";
import { IAccountState, initialState } from "./state";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { actions } from "./actions";

const account: Module<IAccountState, any> = {
    actions,
    getters,
    mutations,
    namespaced: true,
    state: initialState,
};

export { account };
